import { applyDiagnosticJourneyExplanation } from './diagnosticJourneyExplanations.js';
import { applyJourneyBatch5Explanation } from './journeyBatch5Explanations.js';
import { applyJourneyBatch8Explanation } from './journeyBatch8Explanations.js';
import { applyJourneyTerminologyCoverage } from './journeyTerminologyCoverage.js';

// Sprint 3: restrained, stage-specific What You Might Hear selections for
// Diagnostics & Procedures. The aim is orientation, not reproducing the whole
// phrase catalogue inside each Journey.
const DIAGNOSTIC_STAGE_PHRASES = Object.freeze({
  mri: Object.freeze([
    Object.freeze(['mriScan']),
    Object.freeze(['cannula', 'monitoring']),
    Object.freeze(['resultsPending', 'followUp']),
  ]),
  ct: Object.freeze([
    Object.freeze(['ctScan']),
    Object.freeze(['cannula', 'monitoring']),
    Object.freeze(['resultsPending', 'followUp']),
  ]),
  ultrasound: Object.freeze([
    Object.freeze(['scan']),
    Object.freeze([]),
    Object.freeze(['resultsPending', 'followUp']),
  ]),
  endoscopy: Object.freeze([
    Object.freeze(['nilByMouth', 'consent']),
    Object.freeze(['cannula', 'proceduralSedation', 'analgesia', 'monitoring', 'biopsy']),
    Object.freeze(['recovery', 'resultsPending', 'safetyNetting', 'followUp']),
  ]),
  radiotherapy: Object.freeze([
    Object.freeze(['radiotherapy', 'oncology', 'consent', 'scan']),
    Object.freeze(['radiotherapy', 'treatmentCycle', 'sideEffects', 'clinicalNurseSpecialist']),
    Object.freeze(['sideEffects', 'supportiveCare', 'followUpScan', 'followUp']),
  ]),
  chemotherapy: Object.freeze([
    Object.freeze(['systemicAntiCancerTreatment', 'chemotherapy', 'bloodTests', 'oncology', 'clinicalNurseSpecialist', 'cancerMdt']),
    Object.freeze(['treatmentCycle', 'cancerDayUnit', 'cannula', 'piccLine', 'port', 'antiemetic', 'sideEffects']),
    Object.freeze(['neutropenia', 'safetyNetting', 'supportiveCare', 'followUp']),
  ]),
});

export function applyDiagnosticJourneyStageQuality(templateId, stages = []) {
  const phraseStages = DIAGNOSTIC_STAGE_PHRASES[templateId];
  // Keep non-diagnostic Journeys referentially unchanged. genericJourneyRuntime
  // uses that identity to decide whether to continue to Specialty/Major Pathway
  // enrichment; returning a newly mapped array here would silently bypass it.
  if (!phraseStages || phraseStages.length !== stages.length) return stages;

  const qualityStages = stages.map((stage, index) => ({ ...stage, phraseKeys: [...phraseStages[index]] }));
  return applyJourneyTerminologyCoverage(templateId, applyJourneyBatch8Explanation(templateId, applyJourneyBatch5Explanation(templateId, applyDiagnosticJourneyExplanation(templateId, qualityStages))));
}
